import {
  CoeOfferDetailEntity,
  CoeOfferEntity,
  CoeOfferStrategyDirectionEntity,
} from '@genial/services';
import { ResponsesCoeMarketStatusResponse } from '@genial/services/dist/models';
import { atom } from 'recoil';

import { pagination } from '../constants';
import {
  StructuredOperationsOffersParams,
  StructuredOperationsOffersBySearchTerm,
  StructuredOperationBillingTypeSelected,
} from '../types';

export const structuredOperationsOffersAllState = atom({
  key: 'structuredOperationsOffersAllState',
  default: [] as CoeOfferEntity[],
});

export const structuredOperationsOffersParamsState = atom({
  key: 'structuredOperationsOffersParamsState',
  default: {
    ...pagination,
  } as StructuredOperationsOffersParams,
});

export const structuredOperationsBySearchTermState = atom({
  key: 'structuredOperationsBySearchTermState',
  default: [] as CoeOfferEntity[],
});

export const structuredOperationsOffersBySearchTermParamsState = atom({
  key: 'structuredOperationsOffersBySearchTermParamsState',
  default: {
    ...pagination,
    skipEndpointCall: true,
  } as StructuredOperationsOffersBySearchTerm,
});

export const structuredOperationsOptionBillingTypeSelectedState = atom({
  key: 'structuredOperationsOptionBillingTypeSelectedState',
  default: {} as StructuredOperationBillingTypeSelected,
});

export const structuredOperationsDetailsState = atom({
  key: 'structuredOperationsDetailsState',
  default: {} as CoeOfferDetailEntity,
});

export const structuredOperationProductSelectedState = atom({
  key: 'structuredOperationProductIdState',
  default: {} as CoeOfferEntity,
});

export const structuredOperationsOptionsFilterState = atom({
  key: 'structuredOperationsOptionsFilterState',
  default: { data: {} as CoeOfferStrategyDirectionEntity },
});

export const structuredOperationsMarketStatusState = atom({
  key: 'structuredOperationsMarketStatusState',
  default: {} as ResponsesCoeMarketStatusResponse,
});
